import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'src/app/services/dialog-service.service';

@Component({
  selector: 'app-dialog-over-view',
  templateUrl: './dialog-over-view.component.html',
  styleUrls: ['./dialog-over-view.component.scss']
})
export class DialogOverViewComponent {

  constructor(public dialogRef: MatDialogRef<DialogOverViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,) { }

  okClick(){
    this.dialogRef.close();
  }

  confirmed(){
    this.dialogRef.close({data: true});
  }
}
